module.exports = __webpack_public_path__ + "img/Gallery_2_23.2581060b.jpeg";